import React, { useState, useEffect, useContext, useCallback } from 'react';
import {
  uploadFile,
  createkyc,
  updatekyc,
  deletekyc,
  sanctionIoHits,
  createNotification,
  getkycRiskAssessment,
  createKycNestedSanctionComment,
  getkyc,
  updatekycStatus,
  createkycRiskAssessment,
  updatekycRiskAssessment,
  getAllUsers,
  getKycClientRecords,
  kycRiskReview,
} from '../../../../API/Api.js';
import { Card } from '../../../shared/utils.js';
import FormStatusEnum from '../../../../data/FormStatusEnum.js';
import { DateTime } from 'luxon';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import SanctionsioScreeningCard from './SanctionsioScreeningCard.js';
import SubmissionCard from '../components/SubmissionCard.js';
import SubmissionCardVideoLaw from '../SubmissionCard_Video_Law.js';
import { jwtDecode } from 'jwt-decode';
import { TokenContext } from '../../../../App.js';
import { NewRiskLevel } from '../enums.js';
import Modal from '../../../shared/Modal.js';
import { useNavigate } from 'react-router-dom';
import DetailDrawer from '../../../common/DetailDrawer.js';
import Loading from '../../../shared/Loading.js';
const rcaTooltip =
  'RCA (Relatives and Close Associates) - Immediate family members or close social or professional contacts of a government or political official, or senior executive – meaning spouses, parents, siblings, children, and spouses’ parents and siblings.';
let isKycDataExpired;
let expiredPartyId = [];
const _RiskAssessment = ({ clientFormId, userType, currentUrl, formAuthority }) => {
  const [formDataLength, setFormDataLength] = useState();
  const [apiRefreshTime, setApiRefreshTime] = useState();
  const [allFormData, setAllFormData] = useState([]);
  const [formData, setFormData] = useState({
    pepHits: [],
    crimesHits: [],
    sanctionsHits: [],
    highRiskJurisdictionHits: [],
    adverseNewsHits: [],
    riskLevel: '',
    hasFilledEdd: false,
    newRiskLevel: '',
    sourceOfWealthDocumentURL: '',
    otherDocumentsURL: '',
    managementSupportDocumentURL: '',
    enhancedOngoingMonitoringRelationship: '',
    additionalDocuments: [],
  });
  const [kycDataIdentity, setKycDataIdentity] = useState([
    { identificationDocumentLink: '', identificationExpiryDate: '' },
  ]);
  const [selectedDate, setSelectedDate] = useState();
  const [kycData, setKycData] = useState();
  const [loading, setLoading] = useState(true);
  const [allreviewers, setAllreviewers] = useState([]);
  const [reassessmentItems, setReassessmentItems] = useState([]);
  const userRole = localStorage.getItem('role');
  const [encodedAccessToken] = useContext(TokenContext);
  const decodedToken = jwtDecode(encodedAccessToken);
  const [originalRiskLevel, setOriginalRiskLevel] = useState(undefined);
  const [idExpirynDataArr, setIdExpirynDataArr] = useState([]);
  const [detailDrawer, setDetailDrawer] = useState({ isOpen: false, summary: null }); // 新增抽屉状态

  let disabled = false;
  const navigate = useNavigate();

  if (decodedToken.role == 'viewer') {
    disabled = true;
  }

  // 打开详情抽屉
  const openDetailDrawer = summary => {
    setDetailDrawer({ isOpen: true, summary });
  };

  // 关闭详情抽屉
  const closeDetailDrawer = () => {
    setDetailDrawer({ isOpen: false, summary: null });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let allreviewers = (await getAllUsers()).data;
        allreviewers = allreviewers.filter(users => users.role !== 'preparer' && users.role !== 'viewer');
        setAllreviewers(allreviewers);

        const currentKycData = (await getkyc(clientFormId).then(response => response.data)) || {};
        await getIdExpiryRecords(currentKycData);

        const resultPastRiskData = await getAllRiskFilterData(clientFormId);
        if (resultPastRiskData.length === 0) {
          const kycRiskData = await createRiskData(clientFormId);

          resultPastRiskData.push(kycRiskData);
        }
        setAllFormData(resultPastRiskData);
        setFormDataLength(resultPastRiskData.length);
        const displayedRiskData = resultPastRiskData[0];
        if (displayedRiskData) {
          setApiRefreshTime(displayedRiskData?.apiRefreshTime);
          if (!displayedRiskData.informationConsistent) {
            displayedRiskData.informationConsistent = 'yes';
          }
          if (!displayedRiskData.updatedDueDilligence) {
            displayedRiskData.updatedDueDilligence = 'yes';
          }
          displayedRiskData.createDate = currentKycData.createDate;
          const updateFormData = {
            ...displayedRiskData,
            nextRescreeningDate: currentKycData.nextRescreeningDate,
          };
          setFormData(updateFormData);
          setOriginalRiskLevel(displayedRiskData.riskLevel);

          setSelectedDate(displayedRiskData.screenedDate);
          const reassessmentData = [];
          ['pepHits', 'crimesHits', 'sanctionsHits', 'highRiskJurisdictionHits', 'adverseNewsHits'].forEach(key => {
            displayedRiskData[key]?.forEach((item, index) => {
              if (item.response === 'Yes') {
                reassessmentData.push({
                  key,
                  index,
                  displayName: item.name || item.title || 'Unnamed Entry',
                });
              }
            });
          });
          setReassessmentItems(reassessmentData);
        }
        const kycDataDetails = await getkyc(clientFormId).then(response => response.data);
        setKycData(kycDataDetails);
        setLoading(false);
      } catch (e) {
        console.error(e);
        console.error('error fetching sanctions.io data');
      }
    };
    fetchData();
  }, []);

  const handleDateChange = e => {
    const { name, value } = e.target;
    const displayForm = allFormData.filter(pastFormData => pastFormData._id == value)[0];
    setFormData(displayForm);

    const reassessmentData = [];
    ['pepHits', 'crimesHits', 'sanctionsHits', 'highRiskJurisdictionHits', 'adverseNewsHits'].forEach(key => {
      displayForm[key]?.forEach((item, index) => {
        if (item.response === 'Yes') {
          reassessmentData.push({
            key,
            index,
            displayName: item.name || item.title || 'Unnamed Entry',
          });
        }
      });
    });
    setReassessmentItems(reassessmentData);
    toast.success('Changed to: ' + value);
  };

  async function getIdExpiryRecords(currentKycData) {
    const clientRecords = (await getKycClientRecords(clientFormId).then(response => response.data)) || {};
    isKycDataExpired = checkIdExpired(currentKycData.details);
    if (currentKycData?.type == 'individual') {
      const clientDetail = currentKycData.details;
      const tmpArr = [
        {
          clientName: currentKycData.name,
          identificationExpiryDate: clientDetail.identificationExpiryDate,
          identificationDocumentURL: clientDetail.identificationDocumentURL,
          isRecord: false,
        },
      ];
      clientRecords.forEach(clientRecord => {
        tmpArr.push({
          clientName: clientRecord.name,
          identificationExpiryDate: clientRecord.identificationExpiryDate,
          identificationDocumentURL: clientRecord.identificationDocumentURL,
          isRecord: true,
        });
      });
      setIdExpirynDataArr(tmpArr);
    } else if (currentKycData?.type == 'entity') {
      const tmpArr = [];
      currentKycData.details?.connectedParty.forEach(party => {
        tmpArr.push({
          clientName: party.name,
          identificationExpiryDate: party.identificationExpiryDate,
          identificationDocumentURL: party.identificationDocumentURL,
          isRecord: false,
        });
        const curPartyName = party.name;
        clientRecords.forEach(clientRecord => {
          if (clientRecord.partyName === curPartyName) {
            tmpArr.push({
              clientName: curPartyName,
              identificationExpiryDate: clientRecord.identificationExpiryDate,
              identificationDocumentURL: clientRecord.identificationDocumentURL,
              isRecord: true,
            });
          }
        });
      });
      setIdExpirynDataArr(tmpArr);
    }
  }

  const handleInputChange = e => {
    const { name, value } = e.target;
    const newFormData = {
      ...formData,
      [name]: value,
    };
    if (name === 'increasesRiskLevel') {
      if (value === 'no') {
        newFormData['requiresImmediateReassessment'] = 'no';
      }
    }

    setFormData(newFormData);
  };

  const handleNestedInputChange = (e, nestedName) => {
    const { name, value } = e.target;
    const newFormData = {
      ...formData,
      [name]: {
        ...formData[name],
        [nestedName]: value,
      },
    };
    setFormData(newFormData);
  };

  const handleNestedArrayInputChange = (e, nestedName, index) => {
    let { name, value } = e.target;
    name = name.split(' ')[0];
    const newArrayResult = [...formData[name]];
    newArrayResult[index][nestedName] = value;

    const newFormData = {
      ...formData,
      [name]: newArrayResult,
    };
    setFormData(newFormData);

    if (nestedName === 'response') {
      const reassessmentData = [];
      ['pepHits', 'crimesHits', 'sanctionsHits', 'highRiskJurisdictionHits', 'adverseNewsHits'].forEach(key => {
        newFormData[key]?.forEach((item, idx) => {
          if (item.response === 'Yes') {
            reassessmentData.push({
              key,
              index: idx,
              displayName: item.name || item.title || 'Unnamed Entry',
            });
          }
        });
      });
      setReassessmentItems(reassessmentData);
    }
  };

  const handleSubmitNestedArrayComment = async (e, formName, nestedName, index) => {
    if (formData[formName][index][nestedName].trim() == '') {
      return;
    }

    const newCommentEntry = {
      screenedDate: formData.screenedDate,
      kycaml_client_id: clientFormId,
      question: formName + ' ' + index.toString(),
      content: formData[formName][index][nestedName],
      name: decodedToken.name,
      commented_at: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
      comment_id: uuidv4(),
    };
    await createKycNestedSanctionComment(newCommentEntry);
    formData[formName][index].comments.push(newCommentEntry);
    const newCommentArray = formData[formName][index].comments;

    const newPepArray = [...formData[formName]];
    newPepArray[index].comments = newCommentArray;
    newPepArray[index].newComment = '';

    setFormData(prevState => ({
      ...prevState,
      [formName]: newPepArray,
    }));
  };

  const handleSaveForm = async e => {
    updatekycRiskAssessment(formData);
    const newKycData = {
      ...kycData,
      clientFormId: clientFormId,
      updateForm: 'OnGoingMonitoring',
      details: {
        ...kycData.details,
        identificationExpiryDate: kycData?.details?.identificationExpiryDate,
        identificationDocumentLink: kycData?.details?.identificationDocumentLink,
      },
    };
    updatekyc(newKycData);
    toast.success(`Assessment saved!`);
  };

  const handleResetClient = async () => {
    const duplicateKycData = {
      ...kycData,
      updatedDate: DateTime.now().toFormat('dd-MM-yyyy HH:mm:ss'),
      submitedDate: DateTime.now().toFormat('dd-MM-yyyy HH:mm:ss'),
      formStatus: FormStatusEnum.PENDING_CLIENT_DETAILS_1,
      maxPage: 1,
    };
    delete duplicateKycData._id;
    delete duplicateKycData.nextRescreeningDate;
    delete duplicateKycData.onGoingMonitoring;

    try {
      await createkyc(duplicateKycData);
      await deletekyc(kycData._id);
      window.location.href = '/kyc-aml/customer-list';
    } catch (e) {
      console.log('Error resetting client');
      toast.error('Something went wrong...');
    }
  };

  const getUpdatedRiskLevel = useCallback(() => {
    if (formData.newRiskLevel === NewRiskLevel.SAME.value) return formData.riskLevel;
    return formData.newRiskLevel;
  }, [formData.newRiskLevel, formData.riskLevel]);

  const hasFilledEdd = () => {
    if (
      formData.sourceOfWealthDocumentURL &&
      formData.managementSupportDocumentURL &&
      formData.otherDocumentsURL &&
      formData.enhancedOngoingMonitoringRelationship?.trim() !== ''
    )
      return true;
    return false;
  };

  const handleSubmitForReview = async e => {
    if (allFormData.length > 1 && !formData.newRiskLevel) {
      toast.error('Please select the new risk level before submitting for review');
      return;
    }
    let newFormData = {
      ...formData,
      hasFilledEdd: hasFilledEdd(),
      riskLevel: getUpdatedRiskLevel(),
      status: 'waiting for review',
      submitPerson: decodedToken.name,
      submitDate: DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss'),
    };
    updatekycRiskAssessment(newFormData);
    updatekycStatus({ formStatus: 'pending_reviewer_review', id: clientFormId });
    setFormData(newFormData);
    toast.success(`Submitted for review!`);
  };

  const handleFileChange = async (e, fileType) => {
    const file = e.target.files[0];
    const { name } = e.target;
    if (!file) {
      return;
    }

    try {
      const data = new FormData();
      data.append('file', file);
      const filename = `${file.name}`;
      const res = await uploadFile(data, filename);
      if (res) {
        setFormData(prevState => ({
          ...prevState,
          [name]: res.data.url,
        }));
      } else {
        toast.error('Invalid file type!');
      }
    } catch (e) {
      toast.error(`Invalid File type uploaded`);
    }
  };

  const getStatusTag = status => {
    if (status == 'new' || status == 'waiting for review') {
      return <span className='text-orange-500'> Yet to be decided by reviewer</span>;
    } else if (status == 'accepted') {
      return <span className='text-green-500'>Accepted</span>;
    } else if (status == 'rejected') {
      return <span className='text-red-500'>Rejected</span>;
    } else {
      return <span className='text-purple-600'>Edge case!!!</span>;
    }
  };

  const handleStatusUpdate = async (e, updatedStatus) => {
    console.log('持续监测页修改');
    // 开启loading
    setLoading(true);
    if (updatedStatus == 'sendBack') {
      formData.status = '';
      formData.reviewerReviewEmail = '';
    } else {
      formData.reviewStatus = 'Reviewed';
    }
    const newFormData = { ...formData };
    setFormData(newFormData);
    updatekycStatus({ id: clientFormId, reviewStatus: formData.reviewStatus });
    createNotification({
      type: 'KYC',
      text: `${kycData.name} review status has changed to Reviewed`,
      date: DateTime.now().toFormat('dd-MM-yyyy HH:mm:ss'),
    });
    const res = await updatekycRiskAssessment(newFormData);
    if (updatedStatus != 'sendBack') {
      runAssessmentApiType();
    }
    if (res.data.success) {
      toast.success('Assessment updated successfully');
      setLoading(false);
    } else {
      toast.error('Failed to update assessment');
      setLoading(false);
    }
  };

  const handleRunAssessmentAgain = async e => {
    try {
      toast.info(`Assessment running...`);
      setLoading(true);
      const newRiskEntry = {
        pepHits: [],
        crimesHits: [],
        sanctionsHits: [],
        highRiskJurisdictionHits: [],
        adverseNewsHits: [],
        riskLevel: 'Medium',
        sourceOfWealthDocumentURL: '',
        otherDocumentsURL: '',
        managementSupportDocumentURL: '',
      };
      const creationDate = DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss');
      const kycRiskData = {
        ...newRiskEntry,
        kycaml_client_id: clientFormId,
        screenedDate: creationDate,
      };
      await createkycRiskAssessment(kycRiskData);
      const payload = {
        screenedName: kycData['name'],
        connectedParty: kycData?.details?.connectedParty,
        entityType: kycData['type'],
        kycaml_client_id: kycData['_id'],
        screenedDate: creationDate,
        screeningSource: 'sanctions.io',
      };
      const { pepHits, crimesHits, sanctionsHits, highRiskJurisdictionHits, adverseNewsHits } = (
        await sanctionIoHits(payload)
      ).data;
      setFormData({
        ...kycRiskData,
        pepHits,
        crimesHits,
        sanctionsHits,
        highRiskJurisdictionHits,
        adverseNewsHits,
        screeningSource: 'sanctions.io',
      });
      setReassessmentItems([]);
      toast.success(`Assessment complete!`);
      setLoading(false);
    } catch (e) {
      console.error(e);
      toast.error(`Something went wrong...`);
    }
  };

  const runAssessmentApiType = async e => {
    if (decodedToken?.kycSettings?.apiType === 'amlwatcher') {
      handleRunAssessmentAgainAml();
      return;
    }
    handleRunAssessmentAgain();
  };

  const handleRunAssessmentAgainAml = async e => {
    try {
      toast.info(`Assessment running...`);
      setLoading(true);
      const kycRiskData = await createRiskData(clientFormId);

      setFormData({ ...kycRiskData, screeningSource: 'amlWatcher', _id: kycRiskData._id });
      setReassessmentItems([]);
      toast.success(`Assessment complete!`);
      // const allPastRiskData = await getkycRiskAssessment(clientFormId).then(response => response.data);
      const allData = await getAllRiskFilterData(clientFormId);
      setAllFormData(allData);
      setFormDataLength(allData.length);
      setLoading(false);
    } catch (e) {
      console.error(e);
      toast.error(`Something went wrong...`);
    }
  };
  const getAllRiskFilterData = async rissClientId => {
    const allFormData = await getkycRiskAssessment(rissClientId).then(response => response.data);
    return allFormData.filter(item => !item.status || item.status !== 'accepted');
  };
  const createRiskData = async rissClientId => {
    const creationDate = DateTime.now().setZone('Asia/Singapore').toFormat('dd-MM-yyyy, HH:mm:ss');
    // 3个月后
    const apiRefreshTime = DateTime.now().plus({ months: 3 }).toFormat('dd-MM-yyyy, HH:mm:ss');
    const kycRiskData = {
      questionApiUrl: {
        pepHits: 'amlwatcher',
        crimesHits: 'amlwatcher',
        sanctionsHits: 'amlwatcher',
        highRiskJurisdictionHits: 'amlwatcher',
        adverseNewsHits: 'amlwatcher',
      },
      kycaml_client_id: clientFormId,
      screenedDate: creationDate,
      screeningSource: 'amlwatcher',
      nextRescreeningDate: formData?.nextRescreeningDate,
      createDate: creationDate,
      apiRefreshTime: apiRefreshTime,
    };
    const res = await createkycRiskAssessment(kycRiskData);
    if (res.status === 200) {
      if (!res.data.success) {
        toast.error('Failed to create assessment!');
        return '';
      } else {
        kycRiskData['_id'] = res.data.risk_id;
        return kycRiskData;
      }
    }
  };
  const getRiskTag = risk => {
    const riskClasses = {
      Low: 'text-green-500',
      Medium: 'text-orange-500',
      High: 'text-red-500',
      Edge: 'text-purple-600',
    };
    const riskClass = riskClasses[risk] || riskClasses['Edge'];
    return <span className={`bg-gray-200 py-2 px-4 border border-b-gray-300 ${riskClass}`}>{risk}</span>;
  };

  const handlePartyFileUpload = async (e, field) => {
    const files = e.target.files;
    if (!files) {
      return;
    }
    const additionalDocuments = [];
    for (let file of files) {
      try {
        const data = new FormData();
        data.append('file', file);
        const filename = `${field}_${file.name}`;
        const res = await uploadFile(data, filename, encodedAccessToken);
        additionalDocuments.push({
          filename,
          url: res.data.url,
        });
      } catch (e) {
        console.log(e);
      }
    }
    const displayForm = {
      ...formData,
      additionalDocuments,
    };
    setFormData(displayForm);
    updatekycRiskAssessment(displayForm);
  };

  const handleFileRemove = async (fileName, index) => {
    if (disabled) {
      return;
    }
    const updatedFormData = { ...formData };
    updatedFormData.additionalDocuments.splice(index, 1);
    setFormData(updatedFormData);
    updatekycRiskAssessment(updatedFormData);
  };

  function handleIdFileChange(e, idx, idExpirynData) {
    const file = e.target.files[0];
    idExpirynData.file = file;
  }

  function handleIdDateChange(e, idx, idExpirynData) {
    const { name, value } = e.target;
    idExpirynData[name] = value;
  }

  async function changeExpiryDate(idExpirynData, idx) {
    try {
      if (idExpirynData.file && idExpirynData.identificationExpiryDate) {
        const data = new FormData();
        data.append('file', idExpirynData.file);
        const filename = `${idExpirynData.file.name}`;
        const res = await uploadFile(data, filename);
        if (res) {
          let newKycData;
          if (kycData?.type == 'individual') {
            newKycData = {
              _id: kycData._id,
              updateForm: 'OnGoingMonitoringIdExpiryDate',
              type: 'individual',
              name: idExpirynData.name,
              details: {
                identificationExpiryDate: idExpirynData.identificationExpiryDate,
                identificationDocumentURL: res.data.url,
              },
            };
          } else if (kycData?.type == 'entity') {
            newKycData = {
              _id: kycData._id,
              updateForm: 'OnGoingMonitoringIdExpiryDate',
              type: 'entity',
              name: idExpirynData.name,
              details: {
                partyName: idExpirynData.clientName,
                identificationExpiryDate: idExpirynData.identificationExpiryDate,
                identificationDocumentURL: res.data.url,
              },
            };
          }
          await updatekyc(newKycData);
          const currentKycData = (await getkyc(clientFormId).then(response => response.data)) || {};
          getIdExpiryRecords(currentKycData);
          toast.success(`Document saved!`);
        } else {
          toast.error('Invalid file type!');
        }
      } else {
        toast.error('Choose ID file and Expiry date firstly.');
      }
    } catch (e) {
      console.error(e);
      toast.error(`Error`);
    }
  }

  async function selectTestData() {
    try {
      toast.info(`Assessment running...`);
      const kycRiskData = {
        riskLevel: 'Low',
        kycaml_client_id: clientFormId,
        screeningSource: 'amlwatcher',
        pepHits: [
          {
            name: 'Jho Low (Relevant Party 1)',
            dataSource:
              'Wikipedia is a free online encyclopedia that is created and edited by volunteers around the world. It is hosted by the Wikimedia Foundation. This link provides list of con artists internationally.',
            si_identifier: 'Jho Low',
            federal_register_notice:
              'Jho Low has been flagged as a Special Interest Person (SIP) due to his involvement in the theft of billions of US dollars from the 1MDB fund. This information is sourced from a Wikipedia entry listing con artists internationally. His activities have raised significant concerns regarding financial misconduct on an international scale.',
            source_list_url: 'https://en.wikipedia.org/wiki/List_of_con_artists',
            response: 'No',
            justification: '',
            newComment: '',
            comments: [],
            sourceDescription: null,
            sourceCategories: null,
            birth_incorporation_date: null,
            nationality: null,
            risk_level: null,
          },
        ],
        crimesHits: [
          {
            name: 'Jho Low (Main)',
            dataSource: 'Wikipedia- List of Criminals',
            si_identifier: 'Jho Low',
            federal_register_notice:
              'Jho Low has been flagged as a Special Interest Person (SIP) due to his involvement in the theft of billions of US dollars from the 1MDB fund. This information is sourced from a Wikipedia entry listing con artists internationally. His activities have raised significant concerns regarding financial misconduct on an international scale.',
            source_list_url: 'https://en.wikipedia.org/wiki/List_of_con_artists',
            response: 'No',
            justification: '',
            newComment: '',
            comments: [],
            sourceDescription: null,
            sourceCategories: null,
            birth_incorporation_date: null,
            nationality: null,
            risk_level: null,
            matched_rca: false,
            summary: { name: ['Jho Low'], countries: [] },
          },
        ],
        sanctionsHits: [],
        adverseNewsHits: [
          {
            title: 'Basquiat and Picasso Paintings Seized After 1MDB Scandal Sell For Combined $35 Million (Main)',
            url: 'https://www.forbes.com/sites/zacharyfolk/2025/09/04/heres-why-the-us-government-just-sold-basquiat-and-picasso-paintings-for-35-million-combined-at-auction/',
            description:
              'Malaysian financier accused of orchestrating one of the largest embezzlement schemes in history, using funds from the 1MDB development fund for personal lavish spending and backing a film production company.',
            response: 'No',
            justification: '',
            comments: [],
            sourceDescription: null,
            sourceCategories: null,
            birth_incorporation_date: null,
            nationality: null,
            risk_level: null,
            matched_rca: false,
            summary: {
              name: ['Jho Low'],
              birth_incorporation_date: [],
              unique_identifier: 'demo-amlwatcher',
              adverse_keywords: [
                {
                  scandal: 4,
                  embezzlement: 5,
                  fraud: 2,
                  corruption: 2,
                  fugitive: 4,
                  stolen: 1,
                  allegations: 2,
                  conspiracy: 3,
                  'money-laundering': 1,
                  scam: 1,
                  laundering: 2,
                  accused: 1,
                  controversy: 1,
                  bribery: 1,
                },
              ],
              sentiment_analysis: [],
              entity_type: ['person'],
              sentiment: [],
              sentiment_score: [-3],
            },
          },
        ],
        status: 'new',
        _id: formData._id,
      };
      const res = await updatekycRiskAssessment(kycRiskData);
      if (res.status && res.data.status) {
        if (!res.data.success) {
          toast.error('Failed to update assessment!');
          return;
        } else {
          // fetchData();
        }
      }
    } catch (e) {
      console.error(e);
      toast.error(`Something went wrong...`);
    }
  }

  async function handleReviewAction(key, index, newComment, reviewStatus) {
    // toast.info(`正在审核 ${key} 第 ${index + 1} 条数据...`);
    let form = {
      _id: formData._id,
      key: key,
      index: index,
      reviewStatus: reviewStatus,
      newComment: newComment,
    };
    await kycRiskReview(form);
    toast.success(`Successful review`);
    const allPastRiskData = await getkycRiskAssessment(clientFormId).then(response => response.data);
    setAllFormData(allPastRiskData);
    setFormDataLength(allPastRiskData.length);
    const displayedRiskData = allPastRiskData[0];
    if (displayedRiskData) {
      setApiRefreshTime(displayedRiskData?.apiRefreshTime);
      if (!displayedRiskData.informationConsistent) {
        displayedRiskData.informationConsistent = 'yes';
      }
      if (!displayedRiskData.updatedDueDilligence) {
        displayedRiskData.updatedDueDilligence = 'yes';
      }
      setFormData(displayedRiskData);
      setOriginalRiskLevel(displayedRiskData.riskLevel);
      setSelectedDate(displayedRiskData.screenedDate);
      const reassessmentData = [];
      ['pepHits', 'crimesHits', 'sanctionsHits', 'highRiskJurisdictionHits', 'adverseNewsHits'].forEach(key => {
        displayedRiskData[key]?.forEach((item, index) => {
          if (item.response === 'Yes') {
            reassessmentData.push({ key, index, displayName: item.name || item.title || 'Unnamed Entry' });
          }
        });
      });
      setReassessmentItems(reassessmentData);
    }
  }

  let qnCounter = 1;
  const requireRescreen = formData.newRiskLevel === NewRiskLevel.HIGHER.value;
  const requireHigherRiskLevelPrompt = formData.newRiskLevel === NewRiskLevel.HIGHER.value;

  return (
    <div className="max-w-6xl mx-auto">
      {loading ? (
        <Loading message='Assessment loading...' />
      ) : (
        <div>
          <DetailDrawer isOpen={detailDrawer.isOpen} onClose={closeDetailDrawer} summary={detailDrawer.summary} />
          <Card className='mt-8'>
            <div className='flex justify-between'>
              <span className='mb-1 font-semibold underline text-xl'> On Going Monitoring </span>
              <select
                value={formData.screenedDate}
                onChange={handleDateChange}
                name='selectedDate'
                className='w-5/12 p-1.5 mb-5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none mr-6 focus:border-green-500'
              >
                <option disabled> - History - </option>
                {allFormData
                  .filter(
                    pastFormData =>
                      (!pastFormData.status || pastFormData.status !== 'accepted') &&
                      pastFormData.reviewStatus &&
                      pastFormData.reviewStatus === 'Reviewed'
                  )
                  .reverse()
                  .map((pastFormData, index) => (
                    <option key={pastFormData._id} value={pastFormData._id}>
                      {pastFormData.createDate &&
                      DateTime.fromFormat(pastFormData.createDate, 'dd-MM-yyyy, HH:mm:ss').isValid
                        ? DateTime.fromFormat(pastFormData.createDate, 'dd-MM-yyyy, HH:mm:ss', {
                            zone: 'Asia/Singapore',
                          }).toFormat('dd-MM-yyyy')
                        : 'N/A'}{' '}
                      /{' '}
                      {pastFormData.approvalDate
                        ? DateTime.fromFormat(pastFormData.approvalDate, 'dd-MM-yyyy, HH:mm:ss', {
                            zone: 'Asia/Singapore',
                          }).toFormat('dd-MM-yyyy')
                        : ' '}{' '}
                      - Period {index + 1}
                    </option>
                  ))}
              </select>
              {decodedToken.companyId == 'Test_Company' && (
                <button
                  onClick={handleRunAssessmentAgain}
                  className={`bg-green-400 mx-2 hover:bg-green-600 text-white font-semibold py-0.5 px-2 rounded-lg mb-4 w-3/12`}
                >
                  Click to Simulate next month assessment
                </button>
              )}
              {decodedToken.companyId && decodedToken.companyId.toLowerCase().startsWith('test') && (
                <button
                  onClick={handleResetClient}
                  className='mx-2 bg-green-500 hover:bg-green-600 text-white font-semibold py-0.5 px-2 rounded-lg mb-4 w-3/12'
                >
                  Click to reset customer
                </button>
              )}
            </div>
          </Card>
          <>
            <SanctionsioScreeningCard
              disabled={disabled}
              questionNumber={qnCounter++}
              handleSubmitComment={handleSubmitNestedArrayComment}
              result={formData}
              formDataLength={formDataLength}
              apiRefreshTime={apiRefreshTime}
              inputName={'pepHits'}
              handleInputChange={handleNestedArrayInputChange}
              question={'Were there any hits for PEP screening?'}
              handleReviewAction={handleReviewAction}
              onOpenDetail={openDetailDrawer}
              fromReviewStatus={formData.reviewStatus}
              tableHeaders={[
                {
                  displayTitle: 'Name/Summary',
                  width: 'w-3/12',
                  dataField: result => (
                    <div className='relative flex items-center space-x-2 group'>
                      <button
                        className='text-blue-500 hover:text-blue-700 mr-1'
                        onClick={e => {
                          e.stopPropagation();
                          if (result?.summary) openDetailDrawer(result.summary);
                        }}
                        title='View details'
                      >
                        ℹ️
                      </button>
                      <span>{`${result?.name} - \n ${result?.title || ''}`}</span>
                      {result?.matched_rca && (
                        <div className='relative'>
                          <span className='inline-block bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded'>
                            RCA
                          </span>
                          <div className='absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 top-full mt-1 z-10 w-64'>
                            {rcaTooltip}
                          </div>
                        </div>
                      )}
                    </div>
                  ),
                },
                {
                  displayTitle: 'Data Source',
                  width: 'w-1.5/12',
                  dataField: result => (
                    <>
                      {/* 处理 dataSource 或 dataSources 两种情况 */}
                      {result?.dataSources?.length > 0 ? (
                        result?.dataSources.map((dataSource, index) => (
                          <div key={index}>
                            {dataSource?.url ? (
                              <span>
                                {dataSource?.publisher}
                                <a
                                  className='text-blue-500'
                                  href={dataSource.url}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                >
                                  <svg
                                    className='w-4 h-4 inline ml-1'
                                    fill='none'
                                    stroke='currentColor'
                                    viewBox='0 0 24 24'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                      strokeWidth={2}
                                      d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
                                    />
                                  </svg>
                                </a>
                              </span>
                            ) : (
                              <span>{dataSource?.publisher} N/A</span>
                            )}
                          </div>
                        ))
                      ) : (
                        <span>N/A</span>
                      )}
                    </>
                  ),
                },
                { displayTitle: 'True Hit?', width: 'w-1/12', dataField: null },
                { displayTitle: 'Justification', width: 'w-4/12', dataField: null },
              ]}
            />
            <SanctionsioScreeningCard
              disabled={disabled}
              questionNumber={qnCounter++}
              handleSubmitComment={handleSubmitNestedArrayComment}
              result={formData}
              formDataLength={formDataLength}
              apiRefreshTime={apiRefreshTime}
              inputName={'crimesHits'}
              handleInputChange={handleNestedArrayInputChange}
              question={'Were there any hits for crime?'}
              handleReviewAction={handleReviewAction}
              onOpenDetail={openDetailDrawer}
              fromReviewStatus={formData.reviewStatus}
              tableHeaders={[
                {
                  displayTitle: 'Name / DataSource',
                  width: 'w-2/12',
                  dataField: result => (
                    <div className='relative flex items-center space-x-2 group'>
                      <button
                        className='text-blue-500 hover:text-blue-700 mr-1'
                        onClick={e => {
                          e.stopPropagation();
                          if (result?.summary) openDetailDrawer(result.summary);
                        }}
                        title='View details'
                      >
                        ℹ️
                      </button>
                      <span>{`${result.name} \n `}</span>
                      {result?.matched_rca && (
                        <div className='relative'>
                          <span className='inline-block bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded'>
                            RCA
                          </span>
                          <div className='absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 top-full mt-1 z-10 w-64'>
                            {rcaTooltip}
                          </div>
                        </div>
                      )}
                    </div>
                  ),
                },
                {
                  displayTitle: 'Data Source',
                  width: 'w-1.5/12',
                  dataField: result => (
                    <>
                      {/* 处理 dataSource 或 dataSources 两种情况 */}
                      {result?.dataSources?.length > 0 ? (
                        result?.dataSources.map((dataSource, index) => (
                          <div key={index}>
                            {dataSource?.url ? (
                              <span>
                                {dataSource?.publisher}
                                <a
                                  className='text-blue-500'
                                  href={dataSource.url}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                >
                                  <svg
                                    className='w-4 h-4 inline ml-1'
                                    fill='none'
                                    stroke='currentColor'
                                    viewBox='0 0 24 24'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      strokeLinecap='round'
                                      strokeLinejoin='round'
                                      strokeWidth={2}
                                      d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
                                    />
                                  </svg>
                                </a>
                              </span>
                            ) : (
                              <span>{dataSource?.publisher} N/A</span>
                            )}
                          </div>
                        ))
                      ) : (
                        <span>N/A</span>
                      )}
                    </>
                  ),
                },
                { displayTitle: 'True Hit?', width: 'w-1/12', dataField: null },
                { displayTitle: 'Justification', width: 'w-5/12', dataField: null },
              ]}
            />
            <SanctionsioScreeningCard
              disabled={disabled}
              questionNumber={qnCounter++}
              handleSubmitComment={handleSubmitNestedArrayComment}
              result={formData}
              formDataLength={formDataLength}
              apiRefreshTime={apiRefreshTime}
              inputName={'sanctionsHits'}
              handleInputChange={handleNestedArrayInputChange}
              question={'Were there any hits for sanctions?'}
              handleReviewAction={handleReviewAction}
              onOpenDetail={openDetailDrawer}
              fromReviewStatus={formData.reviewStatus}
              tableHeaders={[
                {
                  displayTitle: 'Name',
                  width: 'w-3/12',
                  dataField: result => (
                    <div className='relative flex items-center space-x-2 group'>
                      <button
                        className='text-blue-500 hover:text-blue-700 mr-1'
                        onClick={e => {
                          e.stopPropagation();
                          if (result?.summary) openDetailDrawer(result.summary);
                        }}
                        title='View details'
                      >
                        ℹ️
                      </button>
                      <span>{result.name}</span>
                      {result?.matched_rca && (
                        <div className='relative'>
                          <span className='inline-block bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded'>
                            RCA
                          </span>
                          <div className='absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 top-full mt-1 z-10 w-64'>
                            {rcaTooltip}
                          </div>
                        </div>
                      )}
                    </div>
                  ),
                },
                {
                  displayTitle: 'Data Source',
                  width: 'w-1.5/12',
                  dataField: result => (
                    <>
                      {/* 处理 sanctionHits 的 dataSources 数据结构 */}
                      {result?.dataSources?.length > 0 ? (
                        (() => {
                          const firstDataSource = result.dataSources[0];
                          return (
                            <div className='space-y-1'>
                              {/* Country */}
                              {firstDataSource?.country?.[0] && (
                                <div className='text-sm'>
                                  <span className='font-medium'>Country: </span>
                                  {firstDataSource.country[0]}
                                </div>
                              )}

                              {/* Reason */}
                              {firstDataSource?.reason?.[0] && (
                                <div className='text-sm'>
                                  <span className='font-medium'>Reason: </span>
                                  {firstDataSource.reason[0]}
                                </div>
                              )}

                              {/* Sanction Type */}
                              {firstDataSource?.sanction_type?.[0] && (
                                <div className='text-sm'>
                                  <span className='font-medium'>Type: </span>
                                  {firstDataSource.sanction_type[0]}
                                </div>
                              )}

                              {/* Sanctioning Authority */}
                              {firstDataSource?.sanctioning_authority?.[0] && (
                                <div className='text-sm'>
                                  <span className='font-medium'>Authority: </span>
                                  {firstDataSource.sanctioning_authority[0]}
                                </div>
                              )}

                              {/* Reference Link */}
                              {(firstDataSource?.sanction_source?.[0] || firstDataSource?.reference_link?.[0]) && (
                                <div className='text-sm'>
                                  <span className='font-medium'>Reference: </span>
                                  <a
                                    className='text-blue-500'
                                    href={firstDataSource.sanction_source?.[0] || firstDataSource.reference_link?.[0]}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                  >
                                    <svg
                                      className='w-4 h-4 inline ml-1'
                                      fill='none'
                                      stroke='currentColor'
                                      viewBox='0 0 24 24'
                                      xmlns='http://www.w3.org/2000/svg'
                                    >
                                      <path
                                        strokeLinecap='round'
                                        strokeLinejoin='round'
                                        strokeWidth={2}
                                        d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
                                      />
                                    </svg>
                                  </a>
                                </div>
                              )}
                            </div>
                          );
                        })()
                      ) : (
                        <span>N/A</span>
                      )}
                    </>
                  ),
                },
                { displayTitle: 'True Hit?', width: 'w-1/12', dataField: null },
                { displayTitle: 'Justification', width: 'w-5/12', dataField: null },
              ]}
            />
            {decodedToken?.kycSettings?.apiType != 'amlwatcher' && (
              <SanctionsioScreeningCard
                disabled={disabled}
                questionNumber={qnCounter++}
                handleSubmitComment={handleSubmitNestedArrayComment}
                result={formData}
                formDataLength={formDataLength}
                apiRefreshTime={apiRefreshTime}
                inputName={'highRiskJurisdictionHits'}
                handleInputChange={handleNestedArrayInputChange}
                question={'Were there any hits for High Risk Jurisdiction?'}
                handleReviewAction={handleReviewAction}
                onOpenDetail={openDetailDrawer}
                fromReviewStatus={formData.reviewStatus}
                tableHeaders={[
                  {
                    displayTitle: 'Name',
                    width: 'w-3/12',
                    dataField: result => (
                      <div className='relative flex items-center space-x-2 group'>
                        <button
                          className='text-blue-500 hover:text-blue-700 mr-1'
                          onClick={e => {
                            e.stopPropagation();
                            if (result?.summary) openDetailDrawer(result.summary);
                          }}
                          title='View details'
                        >
                          ℹ️
                        </button>
                        <span>{result.name}</span>
                      </div>
                    ),
                  },
                  {
                    displayTitle: 'Data Source',
                    width: 'w-3/12',
                    dataField: result => (
                      <>
                        {result.dataSource}
                        <a
                          className='text-blue-500'
                          href={result?.source_list_url}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {' '}
                          {result.source_list_url}{' '}
                        </a>
                      </>
                    ),
                  },
                  { displayTitle: 'True Hit?', width: 'w-1/12', dataField: null },
                  { displayTitle: 'Justification', width: 'w-5/12', dataField: null },
                ]}
              />
            )}
            <SanctionsioScreeningCard
              disabled={disabled}
              questionNumber={qnCounter++}
              handleSubmitComment={handleSubmitNestedArrayComment}
              result={formData}
              formDataLength={formDataLength}
              apiRefreshTime={apiRefreshTime}
              inputName={'adverseNewsHits'}
              handleInputChange={handleNestedArrayInputChange}
              question={'Are there any adverse news?'}
              handleReviewAction={handleReviewAction}
              onOpenDetail={openDetailDrawer}
              fromReviewStatus={formData.reviewStatus}
              tableHeaders={[
                {
                  displayTitle: 'Title',
                  width: 'w-2.5/12',
                  dataField: result => (
                    <div className='relative flex items-center space-x-2 group'>
                      <button
                        className='text-blue-500 hover:text-blue-700 mr-1'
                        onClick={e => {
                          e.stopPropagation();
                          if (result?.summary) openDetailDrawer(result.summary);
                        }}
                        title='View details'
                      >
                        ℹ️
                      </button>
                      <span>{result.title}</span>
                      {result?.matched_rca && (
                        <div className='relative'>
                          <span className='inline-block bg-red-500 text-white text-xs font-semibold px-2 py-1 rounded'>
                            RCA
                          </span>
                          <div className='absolute hidden group-hover:block bg-gray-800 text-white text-xs rounded py-1 px-2 top-full mt-1 z-10 w-64'>
                            {rcaTooltip}
                          </div>
                        </div>
                      )}
                    </div>
                  ),
                },
                {
                  displayTitle: 'Description',
                  width: 'w-3.5/12',
                  dataField: result => {
                    return (
                      <>
                        {result.description}
                        {result?.url ? (
                          <a className='text-blue-500' href={result?.url} target='_blank' rel='noopener noreferrer'>
                            <svg
                              className='w-4 h-4 inline ml-1'
                              fill='none'
                              stroke='currentColor'
                              viewBox='0 0 24 24'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                strokeLinecap='round'
                                strokeLinejoin='round'
                                strokeWidth={2}
                                d='M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14'
                              />
                            </svg>
                          </a>
                        ) : (
                          <span>N/A</span>
                        )}
                      </>
                    );
                  },
                },
                { displayTitle: 'True Hit?', width: 'w-1/12', dataField: null },
                { displayTitle: 'Justification', width: 'w-5/12', dataField: null },
              ]}
            />
            {reassessmentItems.length > 0 && (
              <Card className='mt-6 border border-yellow-400 bg-yellow-50'>
                <div className='mb-4'>
                  <span className='font-semibold text-xl text-gray-800'>True Hit Resolution</span>
                </div>
                <div className='mb-4'>
                  <p className='text-gray-700 font-medium mb-2'>
                    New True Hits have been detected in the current review period:
                  </p>
                  <div className='bg-white p-3 border border-gray-200 rounded'>
                    {reassessmentItems.map(({ key, index, displayName }, idx) => (
                      <div key={idx} className='text-sm mb-1'>
                        • {key} Entry {index + 1}: {displayName}
                      </div>
                    ))}
                  </div>
                </div>
                <div className='space-y-4'>
                  <div>
                    <label className='block text-gray-700 font-medium mb-2'>
                      Please review if this increases the overall risk level and whether immediate reassessment is
                      required
                    </label>
                    <textarea
                      maxLength={1000}
                      name='reassessmentJustification'
                      value={formData.reassessmentJustification || ''}
                      onChange={handleInputChange}
                      placeholder='Enter your justification and assessment details here...'
                      className='w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
                      rows={4}
                    />
                  </div>
                  <div className='flex items-center'>
                    <span className='text-gray-700 font-medium mr-4'>
                      Does this increase the risk level of the client:
                    </span>
                    <label className='flex items-center mr-4'>
                      <input
                        type='radio'
                        name='increasesRiskLevel'
                        value='yes'
                        onChange={handleInputChange}
                        checked={formData.increasesRiskLevel === 'yes'}
                        className='mr-2 w-4 h-4'
                      />
                      Yes
                    </label>
                    <label className='flex items-center'>
                      <input
                        type='radio'
                        name='increasesRiskLevel'
                        value='no'
                        onChange={handleInputChange}
                        checked={formData.increasesRiskLevel === 'no'}
                        className='mr-2 w-4 h-4'
                      />
                      No
                    </label>
                  </div>
                  {formData.increasesRiskLevel === 'yes' && (
                    <div className='flex items-center'>
                      <span className='text-gray-700 font-medium mr-4'>Does this require immediate reassessment:</span>
                      <label className='flex items-center mr-4'>
                        <input
                          type='radio'
                          name='requiresImmediateReassessment'
                          value='yes'
                          onChange={handleInputChange}
                          checked={formData.requiresImmediateReassessment === 'yes'}
                          className='mr-2 w-4 h-4'
                        />
                        Yes
                      </label>
                      <label className='flex items-center'>
                        <input
                          type='radio'
                          name='requiresImmediateReassessment'
                          value='no'
                          onChange={handleInputChange}
                          checked={formData.requiresImmediateReassessment === 'no'}
                          className='mr-2 w-4 h-4'
                        />
                        No
                      </label>
                    </div>
                  )}
                  {formData.requiresImmediateReassessment === 'yes' && (
                    <div className='flex flex-col items-center mt-4'>
                      <p className='text-black font-semibold mb-4'>
                        There has been an increase in the client's risk level requiring immediate reassessment.
                      </p>
                      <button
                        onClick={() => handleResetClient()}
                        className='bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg'
                      >
                        Redo Risk Assessment
                      </button>
                    </div>
                  )}
                </div>
              </Card>
            )}
          </>
          <Card>
            <div style={{ display: 'flex' }}>
              <div className='w-8/12'>
                <p className='mb-2 font-semibold'> Outcome </p> <hr />
                <p className='my-4'>
                  {' '}
                  The risk level assessed upon initial screening is: {getRiskTag(formData?.riskLevel || 'Edge')}
                </p>
                {allFormData.length > 1 && (
                  <div>
                    <p className='my-4'>
                      {' '}
                      Through ongoing monitoring, the risk level has been determined to be
                      <span className='mx-1'></span>
                      <select
                        name='newRiskLevel'
                        value={formData.newRiskLevel}
                        onChange={handleInputChange}
                        className='mx-2 p-1 border border-gray-300 rounded'
                      >
                        <option value=''>- Please Select -</option>
                        <option value={NewRiskLevel.HIGHER.value}>{NewRiskLevel.HIGHER.label}</option>
                        <option value={NewRiskLevel.LOWER.value}>{NewRiskLevel.LOWER.label}</option>
                        <option value={NewRiskLevel.SAME.value}>{NewRiskLevel.SAME.label}</option>
                      </select>
                      <span className='mx-1'></span>
                      as the initial assessment.
                    </p>
                    {!formData.newRiskLevel && (
                      <p className='text-red-500 text-sm mt-1 font-medium'>
                        * Please select the new risk level before submitting for review
                      </p>
                    )}
                  </div>
                )}
                {requireRescreen && (
                  <div className='flex flex-col items-center mt-4 mb-4'>
                    <p className='text-black font-semibold mb-2'>
                      There has been an increase in the client's risk level. We recommend a rescreen, or filling up the
                      particulars below.
                    </p>
                    <button
                      onClick={() => handleResetClient()}
                      className='bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-2 px-4 rounded-lg'
                    >
                      Redo Risk Assessment
                    </button>
                  </div>
                )}
                {requireHigherRiskLevelPrompt && (
                  <div className='p-2 pb-8 bg-red-100 flex flex-col gap-2'>
                    <div className='flex gap-4'>
                      <p className='font-semibold my-3 flex-1'>
                        Reasons to retain existing client (where there are grounds to suspect the business relationship
                        involves engagement in money laundering or financing of terrorism)
                      </p>
                      <p className='font-semibold my-3 flex-1'>Nature of risk mitigation measures</p>
                    </div>
                    <div className='flex gap-4'>
                      <textarea
                        maxLength={800}
                        name='retainClientReason'
                        placeholder='Enter Reasons to retain existing client'
                        value={formData?.retainClientReason}
                        onChange={handleInputChange}
                        className='flex-1 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
                        rows={3}
                      />
                      <textarea
                        maxLength={800}
                        name='riskMitigation'
                        placeholder='Enter Nature of risk mitigation measures'
                        value={formData?.riskMitigation}
                        onChange={handleInputChange}
                        className='flex-1 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
                        rows={3}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className='w-4/12' style={{ position: 'relative', right: 0, top: '3rem' }}>
                <span htmlFor='fileInput' className='block font-medium text-gray-700 m-1.5'>
                  Additional Document Upload
                </span>
                {formData?.additionalDocuments?.map((documentItem, idx) => (
                  <div className='flex' key={idx}>
                    <a
                      href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${documentItem?.filename}`}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-blue-600 mr-2'
                    >
                      {decodeURIComponent(documentItem?.url?.split('/')?.slice(-1)[0])}
                    </a>
                    <span className='cursor-pointer' onClick={() => handleFileRemove('additionalDocuments', idx)}>
                      {' '}
                      ❌{' '}
                    </span>
                  </div>
                ))}
                <label
                  className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 my-2 rounded'
                  style={{ position: 'relative', top: '1rem' }}
                >
                  Browse
                  <input
                    maxLength={800}
                    type='file'
                    multiple={true}
                    id='fileInput'
                    name='additionalDocument'
                    onChange={e => handlePartyFileUpload(e, 0, 'additionalDocument')}
                    className='hidden'
                  />
                </label>
              </div>
            </div>
            {kycData?.details?.isvVideo === 'yes' && (
              <SubmissionCardVideoLaw
                getRiskTag={getRiskTag}
                formData={formData}
                setFormData={setFormData}
                handleFileChange={handleFileChange}
                getStatusTag={getStatusTag}
                handleStatusUpdate={handleStatusUpdate}
                handleSaveForm={handleSaveForm}
                handleInputChange={handleInputChange}
                currentUrl={currentUrl}
                userRole={userRole}
                formDataLength={formDataLength}
                allreviewers={allreviewers}
                handleSubmitForReview={handleSubmitForReview}
                clientFormId={clientFormId}
                readOnly={false}
                requireHigherRiskLevelPrompt={requireHigherRiskLevelPrompt}
              />
            )}
            {kycData?.details?.isvVideo !== 'yes' && (
              <SubmissionCard
                getRiskTag={getRiskTag}
                formData={formData}
                setFormData={setFormData}
                handleFileChange={handleFileChange}
                getStatusTag={getStatusTag}
                handleStatusUpdate={handleStatusUpdate}
                handleSaveForm={handleSaveForm}
                handleInputChange={handleInputChange}
                currentUrl={currentUrl}
                userRole={userRole}
                formDataLength={formDataLength}
                allreviewers={allreviewers}
                handleSubmitForReview={handleSubmitForReview}
                clientFormId={clientFormId}
                readOnly={false}
                requireHigherRiskLevelPrompt={requireHigherRiskLevelPrompt}
              />
            )}
            {/* {decodedToken?.kycSettings?.apiType === 'amlwatcher' && (
              <button
                onClick={selectTestData}
                disabled={disabled}
                className={`w-2/12 py-1 px-2 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg opacity-30}`}
              >
                test data
              </button>
            )} */}
          </Card>
          <Card>
            <div style={{ display: 'flex' }}>
              <table className='w-full border-collapse border border-gray-300 shadow table-auto'>
                <thead>
                  <tr className='bg-gray-300 text-left'>
                    <th className='p-3 cursor-pointer'>Name</th>
                    <th className='p-2 text-center'>Expiry Date</th>
                    <th className='p-2 cursor-pointer text-center'>Document</th>
                    <th className='p-2 cursor-pointer text-center'>Upload</th>
                    <th className='p-1 text-center'>New Expiry Date</th>
                    <th className='p-2 text-center'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {idExpirynDataArr?.map((idExpirynData, idx) => (
                    <tr
                      key={idExpirynData.identificationDocumentURL}
                      className={
                        idx % 2 === 0 ? 'bg-green-50 hover:bg-green-100 border' : 'bg-white hover:bg-green-100 border'
                      }
                    >
                      <td className='p-2 border'>{idExpirynData.clientName}</td>
                      <td className='p-2 border text-center'>
                        {idExpirynData.identificationExpiryDate == '9999-12-31'
                          ? '-'
                          : idExpirynData.identificationExpiryDate}
                      </td>
                      <td className='p-2 border'>
                        <a
                          href={idExpirynData.identificationDocumentURL}
                          target='_blank'
                          rel='noopener noreferrer'
                          className='text-blue-600 mr-2'
                        >
                          {decodeURIComponent(idExpirynData.identificationDocumentURL?.split('/')?.slice(-1)[0] || '')}
                        </a>
                      </td>
                      <td>
                        {!idExpirynData.isRecord && (
                          <input
                            maxLength={800}
                            type='file'
                            name='identificationDocumentFile'
                            value={idExpirynData.file}
                            onChange={e => handleIdFileChange(e, idx, idExpirynData)}
                            className='w-1/8 p-1.5 focus:outline-none focus:border-green-500'
                          />
                        )}
                      </td>
                      <td>
                        {!idExpirynData.isRecord && (
                          <input
                            maxLength={800}
                            type='date'
                            name='identificationExpiryDate'
                            value={idExpirynData.expireDate}
                            onChange={e => handleIdDateChange(e, idx, idExpirynData)}
                            className='w-1/8 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
                          />
                        )}
                      </td>
                      <td>
                        {!idExpirynData.isRecord && (
                          <div>
                            <Modal
                              title='Confirm Submit'
                              CustomButton={() => (
                                <button className='ml-4 bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600'>
                                  Submit
                                </button>
                              )}
                            >
                              <ConfirmModal
                                changeExpiryDate={changeExpiryDate}
                                idExpirynData={idExpirynData}
                                idx={idx}
                              ></ConfirmModal>
                            </Modal>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
};

export default _RiskAssessment;

function checkIdExpired(currentKyc) {
  const expireDate = currentKyc?.identificationExpiryDate;
  let expired = false;
  if (!expireDate) {
    return expired;
  }
  const givenDate = DateTime.fromFormat(expireDate, 'yyyy-MM-dd');
  const diff = Math.round(givenDate.diff(DateTime.now(), 'days').days);
  if (diff < 0) {
    expired = true;
  }
  return expired;
}

const ConfirmModal = ({ handleCloseModal, changeExpiryDate, idExpirynData, idx }) => {
  return (
    <div className='px-9 py-6'>
      <p className='mb-5'> Are you sure to submit? </p>
      <div className='flex justify-between'>
        <button
          onClick={() => {
            changeExpiryDate(idExpirynData, idx);
            handleCloseModal();
          }}
          className='px-6 py-2 mr-4 border border-green-700 bg-green-500 hover:bg-green-600 text-white'
        >
          {' '}
          Yes{' '}
        </button>
        <button onClick={handleCloseModal} className='px-6 py-2 mx-6 border bg-slate-300'>
          {' '}
          No{' '}
        </button>
      </div>
    </div>
  );
};
